import React from "react";
import styles from "./style.module.scss";

export default function TyreSelect({
  onSelectModeChange,
  selectMode = false,
  disabled = false,
}: {
  onSelectModeChange?: (active: boolean) => void;
  selectMode?: boolean;
  disabled?: boolean;
}) {
  const handleClick = () => {
    if (onSelectModeChange) onSelectModeChange(!selectMode);
  };

  return (
    <div style={{ display: "flex", gap: 8 }}>
      <button
        className={styles.tyreSelect}
        onClick={handleClick}
        type="button"
        disabled={disabled}
      >
        {selectMode ? "Selecting..." : "Snapshot"}
      </button>
    </div>
  );
}
